<div class="searchTopArea subNav appNav">
    <div class="searchBox topSearch">
      <a (click)="onClearInput()"> <span class="icon icon-close"></span> </a>
      <input 
        type="text" 
        class="searchTapTextArea"
        [(ngModel)]="value" 
        [placeholder]="placeholder"
        (keyup.enter)="onEnter($event)"
        (click)="onInputClick()"
      >
      <a class="searchBackBtn" (click)="backPress()">
        <i class="icon icon-back"></i>
      </a>
    </div>
</div>